import { formatMoney, useClientWallet, usePrivacyText } from '@itarget/shared'
import { Box, Icon, IconButton, Typography } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { fidelity } from '../../../redux'
import Sync from '../../Sync'
import { useBalanceStyles } from './styles'
import { useBalanceTranslation } from './translation'

export const Balance = () => {
  const dispatch = useDispatch()
  const { getPrivacyText } = usePrivacyText()
  const balanceClasses = useBalanceStyles()
  const balanceTranslation = useBalanceTranslation()
  const { getBalance, isBalanceLoaded } = useClientWallet()
  const privacy = useSelector((state) => state.fidelity.privacy)

  let { cashbackBalance, pointsBalance, symbol } = getBalance()
  cashbackBalance = formatMoney.toReal(cashbackBalance)
  pointsBalance = formatMoney.toReal(pointsBalance)

  const handlePrivacy = () => {
    dispatch(fidelity.actions.setPrivacy(!privacy))
  }
  const getPrivacyIcon = () => {
    if (privacy) {
      return 'visibility_off'
    }
    return 'visibility'
  }

  return (
    <Box className={balanceClasses.root}>
      <Typography className={balanceClasses.title}>
        {balanceTranslation.balance}
      </Typography>

      <Box className={balanceClasses.container}>
        <Box className={balanceClasses.enableWalletContainer}>
          <Icon className={balanceClasses.walletIcon}>wallet</Icon>
          <IconButton
            onClick={handlePrivacy}
            className={balanceClasses.eyeButtonIcon}
          >
            <Icon>{getPrivacyIcon()}</Icon>
          </IconButton>
        </Box>

        <Box className={balanceClasses.groupedBalanceContainer}>
          <Box className={balanceClasses.balanceContainer}>
            <Box className={balanceClasses.amountContainer}>
              <Typography className={balanceClasses.amount}>
                <span className={balanceClasses.symbol}>{symbol}</span>{' '}
                {!isBalanceLoaded ? <Sync /> : getPrivacyText(cashbackBalance)}
              </Typography>
              <Icon data-display="none" className={balanceClasses.chevronIcon}>
                chevron_right
              </Icon>
            </Box>

            <Typography className={balanceClasses.balanceLabel}>
              {balanceTranslation.cashbackBalance}
            </Typography>
          </Box>

          <Box data-display="none" className={balanceClasses.balanceContainer}>
            <Box className={balanceClasses.amountContainer}>
              <Typography className={balanceClasses.amount}>
                <span className={balanceClasses.symbol}>PTS</span>{' '}
                {!isBalanceLoaded ? <Sync /> : getPrivacyText(pointsBalance)}
              </Typography>
              <Icon className={balanceClasses.chevronIcon}>chevron_right</Icon>
            </Box>

            <Typography className={balanceClasses.balanceLabel}>
              {balanceTranslation.pointsBalance}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
